export enum CredentialRole {
  ISSUER = 'ISSUER',
  VERIFIER = 'VERIFIER',
  HOLDER = 'HOLDER',
  FEDERATION_TRUST_ANCHOR = 'FEDERATION_TRUST_ANCHOR',
}
